import React from "react";
import {verifyInformation} from "../plugins/syncDatas";

export default class Alerts extends React.Component{
    hideAlert(){
        document.querySelector(".alert-container").classList.add("hidden-alert")
    }
    render() {
        return (
            <div className={"alert-container hidden-alert"}>
                <div className="payment-error error">
                    <h1>¡Oh no!</h1>
                    <h2 className="legend-1">Tuvimos un problema al realizar tu cobro</h2>
                    <h3 className="legend-2">El motivo: </h3>
                    <h4 className="mensaje-error">Fondos insuficientes</h4>
                    <div className="btn-container">
                        <button onClick={this.hideAlert} className={"again"}> Volver a intentar</button>
                        <a href="https://apoyo.savethechildren.mx/error-pago" className="legend-3">Prefiero que me marquen</a>
                    </div>
                </div>
                <div className="payment-error secure">
                    <h1 className="legend-4">¡Solo un paso más!</h1>
                    <h2 className="legend-5">Tu tarjeta solicita autorización por parte de tu banco.</h2>
                    <h3 className="legend-6">Por favor realiza este paso y a continuación presiona el boton verificar.</h3>
                    <h4 className="legend-7">La ventana emergente se mostrará en 10 segundos.</h4>
                    <div className="btn-container">
                        <button onClick={verifyInformation} className="again legend-8">Verificar</button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Alerts.js